import React from "react";
import { GatsbyImage } from "gatsby-plugin-image"
import { getIproPropertyImageData } from "../../utils/getImageFromUrl"
import { Box } from "@mui/material"


export const ThumbnailCarousel = ({ images, paginate, currentIndex }) => {

  const getImage = (i) => {
    let pathname = new URL(images[i].url).pathname;

    const image = {
      url: pathname,
      width: 172,
      height: 100,
    }

    const imageData = getIproPropertyImageData({ image, layout: "fullWidth", options: { quality: 50 } })
    return (
      imageData
    )
  }


  return (
    <Box sx={{ maxHeight: 'calc(100vw - 69.6vw)', overflowY: 'hidden' }}>

      <Box sx={{ backgroundColor: 'white', maxHeight: 468, overflowY: 'scroll', position: 'relative', zIndex: 2 }}>

        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gridGap: "20px" }}>
          {images.map((image, i) => {


            let thumbDirection = (selectedIndex) => {
              return (
                currentIndex > selectedIndex ? parseInt(`${selectedIndex - currentIndex}`) : parseInt(`${selectedIndex - currentIndex}`)
              )
            }

            return <Box onClick={() => paginate(thumbDirection(i))}>
              <GatsbyImage alt={image.description} image={getImage(i)} />
            </Box>
          })}
        </Box>
      </Box>
    </Box>
  );
};